import { useStaticQuery, graphql } from 'gatsby';

type TStaff = {
  name: string;
  position: string;
  email: string;
  phone: string;
};

type TLatestFourNewsItemsQuery = {
  allVariablesYaml: {
    list: {
      members: TStaff[];
    }[];
  };
};

const useStaff = () => {
  const { allVariablesYaml } = useStaticQuery<TLatestFourNewsItemsQuery>(
    graphql`
      query Staff {
        allVariablesYaml(filter: { type: { eq: "Staff" } }) {
          list: nodes {
            members: staff {
              name
              phone
              position
              email
            }
          }
        }
      }
    `,
  );

  if (allVariablesYaml.list.length === 1) {
    return allVariablesYaml.list[0].members;
  }

  return [];
};

export { useStaff };
